import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
    wrapper: {
        width: '100%',
        boxShadow: '0px 5px 20px 0px rgba(0, 0, 0, 0.2)',
        borderRadius: '8px',
    },
    summaryContent: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        minWidth: 0,
        gap: 8,
    },
    title: {
        color: ({ theme }) => theme.palette.text.primary,
        fontWeight: 600,
        flex: '0 1 auto',
        minWidth: 0,
        lineHeight: 1.3,
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
        wordBreak: 'break-word',
    },
    subtext: {
        fontSize: '12px',
        display: 'flex',
        flex: '0 0 auto',
        maxWidth: '45%',
        minWidth: 0,
        marginLeft: 'auto',
        justifyContent: 'flex-end',
        color: ({ theme }) => theme.palette.text.primary,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
})